var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIco6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6426 3.47566C13.5763 3.11268 13.2606 2.84961 12.8923 2.84961C7.00553 2.84961 2.2168 6.95431 2.2168 12C2.2168 17.0449 7.00549 21.1504 12.8923 21.1504C13.2606 21.1504 13.5763 20.8866 13.6426 20.5236L13.7211 20.0928C14.6529 14.6109 14.6522 9.16263 13.7196 3.89812L13.6426 3.47566Z",
    fill: "#A1ABB2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2502 5.89812H20.8758C21.3771 5.89812 21.7822 5.55652 21.7822 5.1356C21.7822 4.71469 21.3771 4.37305 20.8758 4.37305H17.2502C16.7489 4.37305 16.3438 4.71465 16.3438 5.13557C16.3438 5.55649 16.7489 5.89812 17.2502 5.89812Z",
    fill: "#A1ABB2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1426 8.94922H17.1035C16.6834 8.94922 16.3438 9.29082 16.3438 9.71174C16.3438 10.1327 16.6834 10.4743 17.1035 10.4743H20.1426C20.5627 10.4743 20.9023 10.1327 20.9023 9.71174C20.9023 9.29082 20.5628 8.94922 20.1426 8.94922Z",
    fill: "#A1ABB2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1426 13.5254H17.1035C16.6834 13.5254 16.3438 13.867 16.3438 14.2879C16.3438 14.7088 16.6834 15.0504 17.1035 15.0504H20.1426C20.5627 15.0504 20.9023 14.7088 20.9023 14.2879C20.9023 13.867 20.5628 13.5254 20.1426 13.5254Z",
    fill: "#A1ABB2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8758 18.0996H17.2502C16.7489 18.0996 16.3438 18.4412 16.3438 18.8621C16.3438 19.283 16.7489 19.6247 17.2502 19.6247H20.8758C21.3771 19.6247 21.7822 19.283 21.7822 18.8621C21.7822 18.4412 21.3771 18.0996 20.8758 18.0996Z",
    fill: "#A1ABB2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco6);
export default __webpack_public_path__ + "static/media/ico-6.7a3046250322f44b28bb87f8583256bc.svg";
export { ForwardRef as ReactComponent };